import { Button, Form, Input, notification } from 'antd';
import axios from 'axios';
import React, { useState } from 'react'
import {useNavigate} from "react-router-dom"
// import axios from 'axios'
import './style.scss'

function ResetPasswordPage() {
    const history = useNavigate();
    const [loading, setLoading] = useState(false);


    function submitFormResetPassword(value) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const email = urlParams.get('email');
        const token = urlParams.get('token');
        const objSubmit = {
            "email": email,
            "newPassword": value.newPassword,
            "confirmNewPassword": value.confirmNewPassword,
            "token": token
        }
        callServiceResetPassword(objSubmit)
    }

    async function callServiceResetPassword(objReset) {
        setLoading(true)
        try {
             await axios.post(`${process.env.REACT_APP_API_HOST}/auth/resetPassword`, objReset , {
                headers:
                {
                    "Content-Type":"application/json"
                } 
            });
            
            notification.success({
                message: 'Success',
                description:`Successful`
              });
              setLoading(false)
              history('/')
              
        } catch (error) {
            console.log('error', error)
            notification.error({
                message: 'Error',
                description:
                 error?.response?.data?.message,
              });
              setLoading(false)

        }
    }


    return (
        <div className='wrap-reset-password-page'>
            <h1>Metaverse Reset Password</h1>

            <Form
                name='reset-password'
                autoComplete="off"
                onFinish={submitFormResetPassword}
            >
               
                <Form.Item
                    name="newPassword"
                    rules={[{ required: true, message: 'Please input your new password!' }]}>
                    <Input type="password" placeholder='New Password'></Input>
                </Form.Item>
                <Form.Item
                    name="confirmNewPassword"
                    rules={[{ required: true, message: 'Please input your confirm new password!' }]}>
                    <Input type="password" placeholder='Confirm New Password'></Input>
                </Form.Item>

                <Button type="primary" htmlType="submit" loading={loading}>
                    ยืนยัน
                </Button>

            </Form>
        </div>
    )
}

export default ResetPasswordPage;